import React from 'react';
import { MachineConnectionIcon } from './MachineStatus';
import { MachineStatusContainer } from './Status.elements';
import { mappedStatuses } from './utils/BUsMachineStatusMapping';

import { formatDate } from 'common/helpers/v1';
import { differenceInMinutes } from 'date-fns';

interface MachineStatusIndicatorProps {
  machineStatus?: string;
  lastConnected?: string;
  isLoading?: boolean;
  isDisconnected?: boolean;
  businessUnit?: string;
}

export const MachineStatusIndicator = ({
  machineStatus,
  lastConnected,
  isLoading,
  isDisconnected,
  businessUnit
}: MachineStatusIndicatorProps): JSX.Element => {
  if (isLoading) return <></>;

  const lastConnectedTime = lastConnected
    ? differenceInMinutes(new Date(), new Date(lastConnected))
    : null;

  // Currently we display connected/disconnected statuses only for protein and DSI.
  // Pascal doesn't have watchdog or any timestamp indicating last recorded state
  if (!businessUnit) return <></>;

  const baseClass = 'machine_status';
  const connected = <div className={baseClass + ` connected`}>Connected</div>;
  const disconnected = <div className={baseClass + ` disconnected`}>Offline</div>;
  const lastConnectedDate = lastConnected
    ? '  (' + formatDate(lastConnected, 'numeric-date-time') + ')'
    : '';

  if (isDisconnected) machineStatus = 'Disconnected';

  const displayStatus =
    machineStatus &&
    mappedStatuses?.[machineStatus] &&
    lastConnectedTime !== null &&
    lastConnectedTime < 6
      ? mappedStatuses[machineStatus]
      : 'Offline';

  return (
    <MachineStatusContainer>
      {machineStatus && displayStatus === 'Connected' ? connected : disconnected}
      <MachineConnectionIcon {...{ displayStatus }} />
      {lastConnectedDate && displayStatus === 'Offline' && (
        <div className={`${baseClass}` + ' last_known_connected'}> {lastConnectedDate} </div>
      )}
    </MachineStatusContainer>
  );
};
